import React from 'react';
import Loadable from 'react-loadable';

import { FirstLoader } from '@swf/first';

const LoadableDepositWizard = Loadable({
  loader: () => import(/* webpackChunkName: "Deposit" */ './DepositWizard'),
  modules: ['./Deposit'],
  loading: () => <FirstLoader />
});

export default LoadableDepositWizard;
